module.exports = __webpack_public_path__ + "static/media/gear-icon-dark.008d3bf2.svg";